/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Complete_ToastInputs */

const en_video_export_complete_toast = /** @type {(inputs: Video_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video export is now complete`)
};

const fr_video_export_complete_toast = /** @type {(inputs: Video_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'exportation video est terminee`)
};

const de_video_export_complete_toast = /** @type {(inputs: Video_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Videoexport ist nun abgeschlossen.`)
};

const it_video_export_complete_toast = /** @type {(inputs: Video_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'esportazione del video è ora completa`)
};

const ru_video_export_complete_toast = /** @type {(inputs: Video_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт видео завершен.`)
};

const es_video_export_complete_toast = /** @type {(inputs: Video_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La exportación de vídeo ahora está completa`)
};

const zh_cn2_video_export_complete_toast = /** @type {(inputs: Video_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频导出已完成`)
};

const ja_video_export_complete_toast = /** @type {(inputs: Video_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオのエクスポートが完了しました`)
};

const hi_video_export_complete_toast = /** @type {(inputs: Video_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात अब पूरा हो गया है।`)
};

const pt_pt2_video_export_complete_toast = /** @type {(inputs: Video_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A exportação do vídeo já foi concluída.`)
};

/**
* | output |
* | --- |
* | "Video export is now complete" |
*
* @param {Video_Export_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_complete_toast = /** @type {((inputs?: Video_Export_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_complete_toast(inputs)
	if (locale === "de") return de_video_export_complete_toast(inputs)
	if (locale === "it") return it_video_export_complete_toast(inputs)
	if (locale === "ru") return ru_video_export_complete_toast(inputs)
	if (locale === "es") return es_video_export_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_complete_toast(inputs)
	if (locale === "ja") return ja_video_export_complete_toast(inputs)
	if (locale === "hi") return hi_video_export_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_complete_toast(inputs)
	return en_video_export_complete_toast(inputs)
});